import { PaymentCenterComponent } from "@/features/payment-center"
import { useAuth } from "@/contexts"
import { Deal } from "@/types"

interface Props {
  isLoading: boolean
  deals: Deal[]
  onRefresh?: () => void
}

// The Payment Center is the core rolled-out surface — available to every logged-in
// client (and to deal managers via View-As). The component itself renders an empty
// state when there's nothing pending, so there's no access gate here.
export const PaymentCenterPage = ({ deals, isLoading, onRefresh }: Props) => {
  const { user } = useAuth()

  if (!user) return null

  return <PaymentCenterComponent deals={deals} isLoading={isLoading} onRefresh={onRefresh} />
}
